const getLocaleDataPluralRules = (lang: string) => {
	switch (lang) {
		case "bg-BG":
			return import("@formatjs/intl-pluralrules/locale-data/bg");
		case "cs-CZ":
			return import("@formatjs/intl-pluralrules/locale-data/cs");
		case "de-DE":
			return import("@formatjs/intl-pluralrules/locale-data/de");
		case "es-ES":
			return import("@formatjs/intl-pluralrules/locale-data/es");
		case "fr-FR":
			return import("@formatjs/intl-pluralrules/locale-data/fr");
		case "hr-HR":
			return import("@formatjs/intl-pluralrules/locale-data/hr");
		case "hu-HU":
			return import("@formatjs/intl-pluralrules/locale-data/hu");
		case "it-IT":
			return import("@formatjs/intl-pluralrules/locale-data/it");
		case "nl-NL":
			return import("@formatjs/intl-pluralrules/locale-data/nl");
		case "pl-PL":
			return import("@formatjs/intl-pluralrules/locale-data/pl");
		case "pt-PT":
			return import("@formatjs/intl-pluralrules/locale-data/pt");
		case "ro-MD":
		case "ro-RO":
			return import("@formatjs/intl-pluralrules/locale-data/ro");
		case "ru-KZ":
		case "ru-RU":
			return import("@formatjs/intl-pluralrules/locale-data/ru");
		case "sk-SK":
			return import("@formatjs/intl-pluralrules/locale-data/sk");
		case "sr-RS":
			return import("@formatjs/intl-pluralrules/locale-data/sr");
		case "tr-TR":
			return import("@formatjs/intl-pluralrules/locale-data/tr");
		case "uk-UA":
			return import("@formatjs/intl-pluralrules/locale-data/uk");
		case "en-PK":
		default:
			return import("@formatjs/intl-pluralrules/locale-data/en");
	}
};

const getLocaleDataRelativeTimeFormat = (lang: string) => {
	switch (lang) {
		case "bg-BG":
			return import("@formatjs/intl-relativetimeformat/locale-data/bg");
		case "cs-CZ":
			return import("@formatjs/intl-relativetimeformat/locale-data/cs");
		case "de-DE":
			return import("@formatjs/intl-relativetimeformat/locale-data/de");
		case "es-ES":
			return import("@formatjs/intl-relativetimeformat/locale-data/es");
		case "fr-FR":
			return import("@formatjs/intl-relativetimeformat/locale-data/fr");
		case "hr-HR":
			return import("@formatjs/intl-relativetimeformat/locale-data/hr");
		case "hu-HU":
			return import("@formatjs/intl-relativetimeformat/locale-data/hu");
		case "it-IT":
			return import("@formatjs/intl-relativetimeformat/locale-data/it");
		case "nl-NL":
			return import("@formatjs/intl-relativetimeformat/locale-data/nl");
		case "pl-PL":
			return import("@formatjs/intl-relativetimeformat/locale-data/pl");
		case "pt-PT":
			return import("@formatjs/intl-relativetimeformat/locale-data/pt");
		case "ro-MD":
		case "ro-RO":
			return import("@formatjs/intl-relativetimeformat/locale-data/ro");
		case "ru-KZ":
		case "ru-RU":
			return import("@formatjs/intl-relativetimeformat/locale-data/ru");
		case "sk-SK":
			return import("@formatjs/intl-relativetimeformat/locale-data/sk");
		case "sr-RS":
			return import("@formatjs/intl-relativetimeformat/locale-data/sr");
		case "tr-TR":
			return import("@formatjs/intl-relativetimeformat/locale-data/tr");
		case "uk-UA":
			return import("@formatjs/intl-relativetimeformat/locale-data/uk");
		case "en-PK":
		default:
			return import("@formatjs/intl-relativetimeformat/locale-data/en");
	}
};

const shouldPolyfillPluralRules = (locale: string | undefined) =>
	!!locale &&
	(!("PluralRules" in Intl) ||
		new Intl.PluralRules("en", { minimumFractionDigits: 2 }).select(1) === "one" ||
		Intl.PluralRules.supportedLocalesOf([locale]).length !== 1);

const hasResolvedOptionsNumberingSystem = (locale: string) => {
	try {
		return "numberingSystem" in new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).resolvedOptions();
	} catch {
		return false;
	}
};

const shouldPolyfillRelativeTimeFormat = (locale: string | undefined) =>
	!!locale &&
	(!("RelativeTimeFormat" in Intl) ||
		Intl.RelativeTimeFormat.supportedLocalesOf([locale]).length !== 1 ||
		!hasResolvedOptionsNumberingSystem(locale));

const shouldPolyfillConstructedStyleSheets = () => {
	return !("replace" in (window.CSSStyleSheet?.prototype ?? {})) || !("adoptedStyleSheets" in Document.prototype);
};

const polyfills = [import("./core-js")];

if (!window.fetch) {
	polyfills.push(import("whatwg-fetch"));
}

if (shouldPolyfillPluralRules(window.lang)) {
	polyfills.push(import("@formatjs/intl-pluralrules/polyfill"));
	polyfills.push(getLocaleDataPluralRules(window.lang));
}

if (shouldPolyfillRelativeTimeFormat(window.lang)) {
	polyfills.push(import("@formatjs/intl-relativetimeformat/polyfill"));
	polyfills.push(getLocaleDataRelativeTimeFormat(window.lang));
}

if (shouldPolyfillConstructedStyleSheets()) {
	polyfills.push(import("construct-style-sheets-polyfill"));
}

Promise.all(polyfills).then(() => import("./main"));
